import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/page/Index'
import Login from '@/page/Login'
import User from '@/page/user/User'
import InfoPush from '@/page/user/InfoPush'
import VipList from '@/page/user/VipList'
import ExchangeCode from '@/page/user/ExchangeCode'
import Article from '@/page/article/Article'
import Videoes from '@/page/video/Videoes'
import Videos from '@/page/video/Videos'
import Video from '@/page/video/Video'
import Videoo from '@/page/video/Videoo'
import VideoTheme from '@/page/video/VideoTheme'
import VideoThemes from '@/page/video/VideoThemes'
import HeadImg from '@/page/headimg/HeadImg'
import TouImg from '@/page/touimg/TouImg'
import Master from '@/page/master/Master'
import Finance from '@/page/finance/Finance'
import FinanceAmount from '@/page/finance/FinanceAmount'
import FinanceCommissionSet from '@/page/finance/FinanceCommissionSet'
import OrderListH5 from '@/page/order/OrderListH5'
import OrderListApp from '@/page/order/OrderListApp'
import Admin from '@/page/admin/Admin'
import Partner from '@/page/partner/Partner'
import Bonus from '@/page/partner/Bonus'
import Returns from '@/page/partner/Returns'
import Gzh from '@/page/user/Gzh'
import Dzhf from '@/page/user/Dzhf'
import GzhXq from '@/page/user/GzhXq'







Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'index',
      component: Index,
      redirect: '/user',
      children: [
        //提现记录
        {
          path: '/finance',
          name: 'finance',
          component: Finance,

        },
        //提成比例设置
        {
          path: '/financeCommissionSet',
          name: 'financeCommissionSet',
          component: FinanceCommissionSet,
        },
        //金额统计
        {
          path: '/financeAmount',
          name: 'financeAmount',
          component: FinanceAmount,
        },
        //公众号消息列表
        {
          path: '/Gzh',
          name: 'Gzh',
          component: Gzh,
        },
        //定制回复
        {
          path: '/Dzhf',
          name: 'Dzhf',
          component: Dzhf,
        },
        //客服消息列表详情
        {
          path: '/GzhXq',
          name: 'GzhXq',
          component: GzhXq,
        },
        
        //消息推送
        {
          path: '/infoPush',
          name: 'infoPush',
          component: InfoPush,
        },
        //生成大师兑换码
        {
          path: '/exchangeCode',
          name: 'exchangeCode',
          component: ExchangeCode,
        },
        //会员列表
        {
          path: '/vipList',
          name: 'vipList',
          component: VipList,
        },


        //分红记录
        {
          path: '/bonus',
          name: 'bonus',
          component: Bonus,
        },
        //股东管理
        {
          path: '/partner',
          name: 'partner',
          component: Partner,
        },
        //股东管理
        {
          path: '/returns',
          name: 'returns',
          component: Returns,
        },
        {
          path: '/user',
          name: 'user',
          component: User,
        },
        {
          path: '/article',
          name: 'article',
          component: Article,
        },

        {
          path: '/videos',
          name: 'videos',
          component: Videos,
        },
        {
          path: '/videoes',
          name: 'videoes',
          component: Videoes,
        },

        {
          path: '/video',
          name: 'video',
          component: Video,
        },
        {
          path: '/videoo',
          name: 'videoo',
          component: Videoo,
        },
        {
          path: '/videotheme',
          name: 'videotheme',
          component: VideoTheme,
        },
        {
          path: '/videothemes',
          name: 'videothemes',
          component: VideoThemes,
        },

        //头像
        {
          path: '/headImg',
          name: 'headImg',
          component: HeadImg,
        },
        //头像
        {
          path: '/touImg',
          name: 'touImg',
          component: TouImg,
        },

        //大师
        {
          path: '/master',
          name: 'master',
          component: Master,
        },


        //网页订单列表
        {
          path: '/orderListH5',
          name: 'orderListH5',
          component: OrderListH5,
        },
        //APP订单列表
        {
          path: '/orderListApp',
          name: 'orderListApp',
          component: OrderListApp,
        },
        //管理员管理
        {
          path: '/admin',
          name: 'admin',
          component: Admin,
        },
      ]


    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js